import { render, staticRenderFns } from "./NewMain.vue?vue&type=template&id=f0a43f8c&"
import script from "./NewMain.vue?vue&type=script&lang=js&"
export * from "./NewMain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports